module.exports = __webpack_public_path__ + "static/img/img-no1.d232aa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping/img-no1.png
// module id = ExsE
// module chunks = 0